import { Dom } from '../../util';
import { Registry } from '../../registry';
import { Node } from '../../model/node';
import { NodeView } from '../../view/node';
import { Base } from '../base';
export class HTML extends Base {
    get html() {
        return this.getHTML();
    }
    set html(val) {
        this.setHTML(val);
    }
    getHTML() {
        return this.store.get('html');
    }
    setHTML(html, options = {}) {
        if (html == null) {
            this.removeHTML(options);
        }
        else {
            this.store.set('html', html, options);
        }
        return this;
    }
    removeHTML(options = {}) {
        return this.store.remove('html', options);
    }
}
(function (HTML) {
    class View extends NodeView {
        render() {
            super.render();
            this.renderHTMLComponent();
            return this;
        }
        confirmUpdate(flag) {
            const ret = super.confirmUpdate(flag);
            return this.handleAction(ret, View.action, () => this.renderHTMLComponent());
        }
        renderHTMLComponent() {
            const $container = this.$(this.container)
                .find('foreignObject > div')
                .empty();
            const component = this.graph.hook.getHTMLComponent(this.cell);
            if (component) {
                if (typeof component === 'string') {
                    $container.html(component);
                }
                else {
                    $container.append(component);
                }
            }
        }
    }
    HTML.View = View;
    (function (View) {
        View.action = 'html';
        View.config({
            bootstrap: [View.action],
            actions: {
                html: View.action,
            },
        });
        NodeView.registry.register('html-view', View);
    })(View = HTML.View || (HTML.View = {}));
})(HTML || (HTML = {}));
(function (HTML) {
    HTML.config({
        view: 'html-view',
        markup: [
            {
                tagName: 'rect',
                selector: 'body',
            },
            {
                tagName: 'foreignObject',
                selector: 'foreignObject',
                children: [
                    {
                        tagName: 'div',
                        ns: Dom.ns.xhtml,
                        selector: 'label',
                        style: {
                            width: '100%',
                            height: '100%',
                            position: 'static',
                            backgroundColor: 'transparent',
                            textAlign: 'center',
                            margin: 0,
                            padding: 0,
                            boxSizing: 'border-box',
                        },
                    },
                ],
            },
            {
                tagName: 'text',
                selector: 'label',
            },
        ],
        attrs: {
            body: {
                refWidth: '100%',
                refHeight: '100%',
            },
            foreignObject: {
                refWidth: '100%',
                refHeight: '100%',
            },
        },
    });
    Node.registry.register('html', HTML);
})(HTML || (HTML = {}));
(function (HTML) {
    HTML.componentRegistry = Registry.create({
        type: 'html componnet',
    });
})(HTML || (HTML = {}));
//# sourceMappingURL=html.js.map